import { render, staticRenderFns } from "./EpgProgramContainer.vue?vue&type=template&id=629d08f4&scoped=true"
import script from "./EpgProgramContainer.vue?vue&type=script&lang=js"
export * from "./EpgProgramContainer.vue?vue&type=script&lang=js"
import style0 from "./EpgProgramContainer.vue?vue&type=style&index=0&id=629d08f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629d08f4",
  null
  
)

export default component.exports